import { lazy } from 'react';

import { SignUpSteps } from './interfaces';

export const SIGN_IN_WIZARD_SCHEMA = {
  [SignUpSteps.checkEmail]: lazy(() => import('./steps/CheckEmailStep')),
  [SignUpSteps.signIn]: lazy(() => import('./steps/SignInStep')),
  [SignUpSteps.confirmEmail]: lazy(() => import('./steps/ConfirmEmailStep')),
  [SignUpSteps.createPassword]: lazy(() => import('./steps/CreatePasswordStep')),
  [SignUpSteps.userName]: lazy(() => import('./steps/UserNameStep')),
  [SignUpSteps.addPicture]: lazy(() => import('./steps/AddPictureStep')),
  [SignUpSteps.plan]: lazy(() => import('./steps/PlanEventStep')),
  [SignUpSteps.invite]: lazy(() => import('./steps/InvitePeopleStep')),
  [SignUpSteps.dancing]: lazy(() => import('./steps/OpenDancingStep')),
};
